module.exports = __webpack_public_path__ + "img/used-ms-excel.04200ba4.svg";